export interface GeneralSharePreviewPayload {
  rows: GeneralSharePreviewEmployer[];
  count: number;
}

export interface GeneralShareEditPayload {
  rows: GeneralShareEditEmployer[];
  count: number;
  selected_count: number;
}

export interface GeneralSharePreviewEmployer {
  status_id: number;
  profile_id: number;
  certification_name: string;
  version: number;
  user_id: number;
  email: string;
  first_name: string;
  last_name: string;
  organization_name: string;
  assignment_count: number;
  created_at: string;
  deleted_at: string;
}

export interface GeneralShareEditEmployer {
  role_id: number;
  profile_id: number;
  email: string;
  organization_name: string;
  first_name: string;
  last_name: string;
  assignment_count: number;
  selected: boolean;
  certification_id: number;
  created_at: string;
  deleted_at: string;
  shared_status_id: number;
  version: number;
}

export interface GeneralShareUpdate {
  selected: boolean;
  profile_id: number;
  certification_id: number;
}

export class TableFilters {
  search = '';
  page = 1;
}
